export const doctors = [
    {
        id: 0,
        name: 'dr. Susan Melinda, Sp.OG. Fellow Infertilitas (NTUH) Fellow Infertilitas & Fellow Endoskopi Ginekologi Reproduksi',
        image: 'dr_susan.png',
        schedules: [
            // {
            //     id: 0,
            //     day: 'Minggu',
            //     time: '-',
            //     artime: [],
            //     available: false,
            //     display: false
            // },
            {
                id: 1,
                day: 'Senin',
                time: ['11.00 - 13.00*'],
                artime: [
                    '11:00',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 2,
                day: 'Selasa',
                time: ['11.00 - 13.00*'],
                artime: [
                    '11:00',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 3,
                day: 'Rabu',
                time: ['11.00 - 13.00*'],
                artime: [
                    '11:00',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 4,
                day: 'Kamis',
                time: ['11.00 - 13.00*'],
                artime: [
                    '11:00',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 5,
                day: 'Jumat',
                time: ['11.00 - 13.00*'],
                artime: [
                    '11:00',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 6,
                day: 'Sabtu',
                time: ['-'],
                artime: [],
                available: false,
                display: true
            }
        ]
    },
    {
        id: 1,
        name: 'dr. Anthony Sudono Riyadi, Sp.OG, M.Sc., DPOGS, DMAS. Fellow Infertilitas',
        image: 'dr_anthony.png',
        schedules: [
            // {
            //     id: 0,
            //     day: 'Minggu',
            //     time: '-',
            //     artime: [],
            //     available: false,
            //     display: false
            // },
            {
                id: 1,
                day: 'Senin',
                time: ['08.00 - 10.00*', '17.00 - 20.00'],
                artime: [
                    '08:00',
                    '09:00',
                    '17:00',
                    '18:00',
                    '19:00'
                ],
                available: true,
                display: true
            },
            {
                id: 2,
                day: 'Selasa',
                time: ['08.00 - 10.00*', '17.00 - 20.00'],
                artime: [
                    '08:00',
                    '09:00',
                    '17:00',
                    '18:00',
                    '19:00'
                ],
                available: true,
                display: true
            },
            {
                id: 3,
                day: 'Rabu',
                time: ['08.00 - 10.00*', '17.00 - 20.00'],
                artime: [
                    '08:00',
                    '09:00',
                    '17:00',
                    '18:00',
                    '19:00'
                ],
                available: true,
                display: true
            },
            {
                id: 4,
                day: 'Kamis',
                time: ['08.00 - 10.00*', '17.00 - 20.00'],
                artime: [
                    '08:00',
                    '09:00',
                    '17:00',
                    '18:00',
                    '19:00'
                ],
                available: true,
                display: true
            },
            {
                id: 5,
                day: 'Jumat',
                time: ['08.00 - 10.00*', '17.00 - 20.00'],
                artime: [
                    '08:00',
                    '09:00',
                    '17:00',
                    '18:00',
                    '19:00'
                ],
                available: true,
                display: true
            },
            {
                id: 6,
                day: 'Sabtu',
                time: ['13.00 - 15.00*'],
                artime: [
                    '13:00',
                    '14:00'
                ],
                available: true,
                display: true
            }
        ]
    },
    {
        id: 2,
        name: 'dr. Julius T Pangayoman, Sp.OG. Fellow Infertilitas',
        image: 'dr_julius.png',
        schedules: [
            // {
            //     id: 0,
            //     day: 'Minggu',
            //     time: '-',
            //     artime: [],
            //     available: false,
            //     display: false
            // },
            {
                id: 1,
                day: 'Senin',
                time: ['11.30 - 13.00*'],
                artime: [
                    '11:30',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 2,
                day: 'Selasa',
                time: ['11.30 - 13.00*'],
                artime: [
                    '11:30',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 3,
                day: 'Rabu',
                time: ['11.30 - 13.00*'],
                artime: [
                    '11:30',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 4,
                day: 'Kamis',
                time: ['11.30 - 13.00*'],
                artime: [
                    '11:30',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 5,
                day: 'Jumat',
                time: ['11.30 - 13.00*'],
                artime: [
                    '11:30',
                    '12:00'
                ],
                available: true,
                display: true
            },
            {
                id: 6,
                day: 'Sabtu',
                time: ['-'],
                artime: [],
                available: false,
                display: true
            }
        ]
    },
    {
        id: 3,
        name: 'Dr. dr. Tita H Madjid,Sp.OG, Subsp.F.E.R',
        image: 'dr_tita.png',
        schedules: [
            // {
            //     id: 0,
            //     day: 'Minggu',
            //     time: '-',
            //     artime: [],
            //     available: false,
            //     display: false
            // },
            {
                id: 1,
                day: 'Senin',
                time: ['14.30 - 16.30*'],
                artime: [
                    '14:30',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 2,
                day: 'Selasa',
                time: ['14.30 - 16.30*'],
                artime: [
                    '14:30',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 3,
                day: 'Rabu',
                time: ['14.30 - 16.30*'],
                artime: [
                    '14:30',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 4,
                day: 'Kamis',
                time: ['14.30 - 16.30*'],
                artime: [
                    '14:30',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 5,
                day: 'Jumat',
                time: ['14.30 - 16.30*'],
                artime: [
                    '14:30',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 6,
                day: 'Sabtu',
                time: ['10.00 - 12.00*'],
                artime: [
                    '10:00',
                    '11:00'
                ],
                available: true,
                display: true
            }
        ]
    },
    {
        id: 4,
        name: 'dr. Hermin Widjaja, Sp.OG. Fellow Infertilitas',
        image: 'dr_hermin.png',
        schedules: [
            // {
            //     id: 0,
            //     day: 'Minggu',
            //     time: '-',
            //     artime: [],
            //     available: false,
            //     display: false
            // },
            {
                id: 1,
                day: 'Senin',
                time: ['10.00 - 17.00*'],
                artime: [
                    '10:00',
                    '11:00',
                    '12:00',
                    '13:00',
                    '14:00',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 2,
                day: 'Selasa',
                time: ['10.00 - 17.00*'],
                artime: [
                    '10:00',
                    '11:00',
                    '12:00',
                    '13:00',
                    '14:00',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 3,
                day: 'Rabu',
                time: ['10.00 - 17.00*'],
                artime: [
                    '10:00',
                    '11:00',
                    '12:00',
                    '13:00',
                    '14:00',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 4,
                day: 'Kamis',
                time: ['10.00 - 17.00*'],
                artime: [
                    '10:00',
                    '11:00',
                    '12:00',
                    '13:00',
                    '14:00',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 5,
                day: 'Jumat',
                time: ['10.00 - 17.00*'],
                artime: [
                    '10:00',
                    '11:00',
                    '12:00',
                    '13:00',
                    '14:00',
                    '15:00',
                    '16:00'
                ],
                available: true,
                display: true
            },
            {
                id: 6,
                day: 'Sabtu',
                time: ['08.00 - 13.00*'],
                artime: [
                    '08:00',
                    '09:00',
                    '10:00',
                    '11:00',
                    '12:00'
                ],
                available: true,
                display: true
            }
        ]
    },
    {
        id: 5,
        name: 'Dr. dr. Arief Setiawan, Sp.OG, Subsp.F.E.R, M.Kes., MMRS.',
        image: 'dr_arif.png',
        schedules: [
            // {
            //     id: 0,
            //     day: 'Minggu',
            //     time: '-',
            //     artime: [],
            //     available: false,
            //     display: false
            // },
            {
                id: 1,
                day: 'Senin',
                time: ['13:00 - 15:00*'],
                artime: [
                    '13:00',
                    '14:00',
                    '15:00'
                ],
                available: true,
                display: true
            },
            {
                id: 2,
                day: 'Selasa',
                time: ['13:00 - 15:00*'],
                artime: [
                    '13:00',
                    '14:00',
                    '15:00'
                ],
                available: true,
                display: true
            },
            {
                id: 3,
                day: 'Rabu',
                time: ['15:00 - 17:00 (on call)'],
                artime: [
                    '15:00',
                    '16:00',
                    '17:00'
                ],
                available: true,
                display: true
            },
            {
                id: 4,
                day: 'Kamis',
                time: ['13:00 - 15:00*'],
                artime: [
                    '13:00',
                    '14:00',
                    '15:00'
                ],
                available: true,
                display: true
            },
            {
                id: 5,
                day: 'Jumat',
                time: ['13:00 - 15:00*'],
                artime: [
                    '13:00',
                    '14:00',
                    '15:00'
                ],
                available: true,
                display: true
            },
            {
                id: 6,
                day: 'Sabtu',
                time: ['09:00 - 11:00*'],
                artime: [
                    '09:00',
                    '10:00',
                    '11:00'
                ],
                available: true,
                display: true
            }
        ]
    },
    // {
    //     id: 3,
    //     name: 'dr. Rima Yulia E., SpOG, (K)-Fer',
    //     image: 'drrima.png',
    //     schedules: [
    //         {
    //             id: 0,
    //             day: 'Minggu',
    //             time: '-',
    //             artime: [],
    //             available: false,
    //             display: false
    //         },
    //         {
    //             id: 1,
    //             day: 'Senin',
    //             time: '-',
    //             artime: [],
    //             available: false,
    //             display: true
    //         },
    //         {
    //             id: 2,
    //             day: 'Selasa',
    //             time: '15.00 - 17.00',
    //             artime: [
    //                 '15:00',
    //                 '16:00'
    //             ],
    //             available: true,
    //             display: true
    //         },
    //         {
    //             id: 3,
    //             day: 'Rabu',
    //             time: '15.00 - 17.00',
    //             artime: [
    //                 '15:00',
    //                 '16:00'
    //             ],
    //             available: true,
    //             display: true
    //         },
    //         {
    //             id: 4,
    //             day: 'Kamis',
    //             time: '15.00 - 17.00',
    //             artime: [
    //                 '15:00',
    //                 '16:00'
    //             ],
    //             available: true,
    //             display: true
    //         },
    //         {
    //             id: 5,
    //             day: 'Jumat',
    //             time: '15.00 - 17.00',
    //             artime: [
    //                 '15:00',
    //                 '16:00'
    //             ],
    //             available: true,
    //             display: true
    //         },
    //         {
    //             id: 6,
    //             day: 'Sabtu',
    //             time: '08.00 - 10.00',
    //             artime: [
    //                 '08:00',
    //                 '09:00'
    //             ],
    //             available: true,
    //             display: true
    //         }
    //     ]
    // },
];






